(function () {
  'use strict';

  // Modal Window
  // ----------------------------------------
  $( '.preventDefault' ).bind('click', function(e) {
    e.preventDefault();
  });

  function closeAllModals() {
    $( 'body' ).removeClass( 'overflow-y-hidden' );

    let modals = $( '.modals' );

    Array.prototype.slice.call(modals).forEach((modal) => {
      $(modal).css( 'display','none' );
    });
  }

  window.openModal = function (modalId) {
    $('#' + modalId).css( 'display','block' );
    $('body').addClass( 'overflow-y-hidden' );

    const videoContainer = $( '#' + modalId + ' .video:first' );

    videoContainer.html( '<iframe frameborder="0" allow="autoplay; encrypted-media" allowfullscreen src="https://www.youtube.com/embed/' + videoContainer.data('video-id') + '"></iframe>' );
  };

  window.closeModal = function (modalId) {
    $( '#' + modalId ).css( 'display','none' );
    $( 'body' ).removeClass( 'overflow-y-hidden' );
  };

  document.onkeydown = function (event) {
    event = event || window.event;

    if (event.keyCode === 27) {
      closeAllModals();
    }
  };
})();
